'use strict';

const ajax = require('superagent');
const events = require('dom-events');

const _ = require('../vendor/lodash/custom');

const msg = require('../messages.js');
const utils = require('../utils.js');

const Form = require('./form.js');

function CommentForm (ref, url, apiKey) {
  Form.apply(this, Array.prototype.slice.call(arguments));

  var refs = {
    root: '[data-ref="community-form"]',

    nameField: '[data-ref="field-input-name-' + ref + '"]',
    nameInput: '[data-ref="input-name-' + ref + '"]',
    nameNotification: '[data-ref="notification-name-' + ref + '"]',

    emailField: '[data-ref="field-input-email-' + ref + '"]',
    emailInput: '[data-ref="input-email-' + ref + '"]',
    emailNotification: '[data-ref="notification-email-' + ref + '"]',

    websiteField: '[data-ref="field-input-website-' + ref + '"]',
    websiteInput: '[data-ref="input-website-' + ref + '"]',
    websiteNotification: '[data-ref="notification-website-' + ref + '"]',

    commentField: '[data-ref="field-textarea-comment-' + ref + '"]',
    commentTextarea: '[data-ref="textarea-comment-' + ref + '"]',
    commentNotification: '[data-ref="notification-comment-' + ref + '"]',

    option: '[data-ref="option-' + ref + '"]'
  };
  _.assign(this.refs, refs);

  this.url = url;
  this.apiKey = apiKey;

  this.payload = {};
}

CommentForm.prototype = new Form();

CommentForm.prototype.gainFocus = function () {
  var nameInput = document.querySelector(this.refs.nameInput);
  nameInput.focus({ preventScroll: true });
};

CommentForm.prototype.clearFields = function () {
  var name = document.querySelector(this.refs.nameInput);
  name.value = '';

  var email = document.querySelector(this.refs.emailInput);
  email.value = '';

  var website = document.querySelector(this.refs.websiteInput);
  website.value = '';

  var comment = document.querySelector(this.refs.commentTextarea);
  comment.value = '';
};

CommentForm.prototype.successConsent = function (response) {
  var _this = this;
  ajax.post(this.url)
    .set({ 'x-api-key': this.apiKey })
    .send(this.payload)
    .then(function (response) {
      var data = response.body.data;
      var form = document.querySelector(_this.refs.form);
      events.emit(form, 'postComment', {
        bubbles: true,
        data: data
      });

      _this.clearFields();
      _this.enableSubmit(msg.comment);
      _this.showFormNotification(msg.commentSuccess);
      window.setTimeout(_this.hideFormNotification.bind(_this), 3000);
    })
    .catch(function (error) {
      _this.enableSubmit(msg.comment);
      if (error.response && error.response.body.message === 'Spam comment detected!') {
        _this.showFormNotification(msg.commentSpam, true);
      } else {
        _this.showFormNotification(msg.unexpected, true);
      }
      window.setTimeout(_this.hideFormNotification.bind(_this), 3000);
    });
};

CommentForm.prototype.errorConsent = function (error) {
  this.enableSubmit(msg.comment);
  this.showFormNotification(msg.unexpected, true);
  window.setTimeout(this.hideFormNotification.bind(this), 3000);
};

CommentForm.prototype.onChange = function (event) {
  var name = utils.findTarget(this.refs.nameInput, event);
  if (name) {
    if (name.validity.valid) {
      this.setValidField(this.refs.nameField);
    } else {
      this.setInvalidField(this.refs.nameField, this.refs.nameInput);
    }
  }

  var email = utils.findTarget(this.refs.emailInput, event);
  if (email) {
    if (email.validity.valid) {
      this.setValidField(this.refs.emailField);
    } else {
      this.setInvalidField(this.refs.emailField, this.refs.emailInput);
    }
  }

  var website = utils.findTarget(this.refs.websiteInput, event);
  if (website) {
    if (website.validity.valid) {
      this.setValidField(this.refs.websiteField);
    } else {
      this.setInvalidField(this.refs.websiteField, this.refs.websiteInput);
    }
  }

  var comment = utils.findTarget(this.refs.commentTextarea, event);
  if (comment) {
    if (comment.validity.valid) {
      this.setValidField(this.refs.commentField);
    } else {
      this.setInvalidField(this.refs.commentField, this.refs.commentTextarea);
    }
  }
};

CommentForm.prototype.onSubmit = function (event) {
  var form = utils.findTarget(this.refs.form, event);
  if (form) {
    event.preventDefault();

    var name = document.querySelector(this.refs.nameInput);
    if (!name.validity.valid) {
      this.setInvalidField(this.refs.nameField, this.refs.nameInput);
      return;
    }

    var email = document.querySelector(this.refs.emailInput);
    if (!email.validity.valid) {
      this.setInvalidField(this.refs.emailField, this.refs.emailInput);
      return;
    }

    var website = document.querySelector(this.refs.websiteInput);
    if (!website.validity.valid) {
      this.setInvalidField(this.refs.websiteField, this.refs.websiteInput);
      return;
    }

    var comment = document.querySelector(this.refs.commentTextarea);
    if (!comment.validity.valid) {
      this.setInvalidField(this.refs.commentField, this.refs.commentTextarea);
      return;
    }

    this.disableSubmit(msg.publishing);

    this.payload.source = location.href;
    this.payload.author = name.value;
    this.payload.email = email.value;
    this.payload.content = comment.value;

    var consentData = {
      name: name.value,
      email: email.value,
      comment: comment.value
    };

    if (website.value) {
      this.payload.website = website.value;
      consentData.website = website.value;
    }

    var serializer = new XMLSerializer();
    var consent = {
      email: email.value,
      form: serializer.serializeToString(form),
      data: consentData,
      privacyPolicy: 'https://rukbottoland.com/politica-de-privacidad/',
      source: location.href
    };

    this.sendConsent(consent);
  }
};

CommentForm.prototype.onClick = function (event) {
  var option = utils.findTarget(this.refs.option, event);
  if (option) {
    event.preventDefault();
    var root = document.querySelector(this.refs.root);
    events.emit(document, 'cancelReply', { bubbles: true });
  }
};

CommentForm.prototype.onPrepareReply = function (event) {
  var dest = event.dest;
  if (dest) {
    var submit = document.querySelector(this.refs.submit);
    submit.value = msg.reply;
    var option = document.querySelector(this.refs.option);
    option.className = option.className.replace(' ' + this.cls.invisible, '');
    this.updatePosition(dest);
    this.scrollToVisible();
    this.gainFocus();
  }

  var comment = event.data;
  if (comment) {
    this.payload.replyTo = comment.Source + ' ' + comment.CreatedAt;
  }
};

CommentForm.prototype.onCancelReply = function (event) {
  this.payload = {};
  var submit = document.querySelector(this.refs.submit);
  submit.value = msg.comment;
  var option = document.querySelector(this.refs.option);
  if (!option.className.includes(this.cls.invisible)) {
    option.className = option.className.concat(' ' + this.cls.invisible);
  }
  this.resetPosition();
};

CommentForm.prototype.onDoneReply = function (event) {
  this.payload = {};
  var submit = document.querySelector(this.refs.submit);
  submit.value = msg.comment;
  var option = document.querySelector(this.refs.option);
  if (!option.className.includes(this.cls.invisible)) {
    option.className = option.className.concat(' ' + this.cls.invisible);
  }
  this.resetPosition();
};

CommentForm.prototype.bindEvents = function () {
  Form.prototype.bindEvents.call(this);

  this.onClick = this.onClick.bind(this);
  events.on(document, 'click', this.onClick);

  this.onPrepareReply = this.onPrepareReply.bind(this);
  events.on(document, 'prepareReply', this.onPrepareReply);

  this.onCancelReply = this.onCancelReply.bind(this);
  events.on(document, 'cancelReply', this.onCancelReply);

  this.onDoneReply = this.onDoneReply.bind(this);
  events.on(document, 'doneReply', this.onDoneReply);
};

module.exports = CommentForm;



//////////////////
// WEBPACK FOOTER
// ./_js/forms/comment.js
// module id = 21
// module chunks = 0 1